import { graphql } from 'react-relay';

export const cutoffListPageFragment = graphql`
  fragment CutOffListPage_page on CutOffPage {
    components(first: 10000) {
      edges {
        node {
          __typename
          ...CutOffList_component
          ...Widget_component @arguments(salesAdmission: "AT")
        }
      }
    }
    breadcrumbs {
      ...Breadcrumb_data
    }
    path
    id
  }
`;
